import React, {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { Loader } from "@googlemaps/js-api-loader";
import { Autocomplete } from '@mui/material';
import { FormControlLabel, TextField, IconButton } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import _ from "lodash";
import ClipLoader from "react-spinners/ClipLoader";
import { Close } from '@mui/icons-material';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import CheckoutForm from "./components/stripe";
import { getCardIcon } from "Util/Utilities";
import { getStates } from "Actions/CareRecipientActions";
import Api, { showLoading } from "Api";
import { _attr } from "Util/Utilities";
import IOSSwitch from "Components/IosSwitch";
import "./IPCAScheduling.css";
import {
  getDayNames,
  getShortMonths,
  calculateAge,
  dateDobFormat,
  toYYYYMMDD,
  timeStringToDate,
  dateDiffHours,
  destOffsetInMillis,
} from "Util/DateUtils";
import { GoogleAutocomplete, PortalDialog } from "Components/CommonComponents";
import SimpleSelect from "Components/SimpleSelect";
import {
  APP_COUNTRY,
  isAU,
  isMY,
  isSG,
  OTHERS,
} from "DataConstants";
import { Div, Img, Txt } from "Components/GenericView";
import {
  CITY_STATES_API,
  getSuburbStatePostcode,
  UNDEF,
} from "Constants";
import { GoogleLocationType } from "Util/Enum";

export interface MedicalBackgroundProps { }
export const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_API_KEY || ""
);
const minDate = new Date(new Date().setFullYear(1910, 0, 1));
const maxDate = new Date();
const win: any = window;
const MedicalBackground: React.FunctionComponent<any> = forwardRef(
  (props, ref) => {
    const {
      languageDropdown,
      validate,
      handleChangeSelect,
      selectedMonth,
      parentState,
      parentSetState,
      title,
      titleDropdown,
      states,
      getStates,
      crData,
      ipca_pricing,
      updateCRData,
      refreshCareownerData,
    } = props;

    const tagInput: any = useRef(null);
    const isInitialMount = useRef(true);
    const [selectSpokenLanguages, setselectSpokenLanguages]: any = useState([]);
    const [state]: any = useState({
      collapse: false,
      memosPhoto: [] as string[],
      othersText: "",
    });

    const { collapse, othersText } = state;
    const [firstName, setFirstName] = useState("");
    const [statesDropDown, setstatesDropDown] = useState([]);
    const [districtDropdown, setdistrictDropdown] = useState([]);
    const [lastName, setLastName] = useState("");
    const [monthDropdown, setMonthDropDown] = useState<any[]>([]);
    const [pair, setPair] = useState<any[]>([]);
    const [dates, setDates] = useState<any>({});
    const [age, setAge] = useState("");
    const [dob, setDob]: any = useState(null);
    const [prevDisease, setPrevDisease] = useState(false);
    const [otherLanguage, setOtherLanguage] = useState("");
    const [diseaseDetail, setDiseaseDetails] = useState("");
    const [facility, setFacility] = useState(false);
    const input: any = useRef(null);
    const [inputFill, setInputFill] = useState(false);
    const [postalCode, setPostalCode] = useState("");
    const [stateMY, setStateMY] = useState("");
    const [districtMY, setDistrictMY] = useState("");

    // for Australia
    const [suburb, setSuburb] = useState("");
    const [city, setCity] = useState("");

    const [bldNo, setBldNo] = useState("");
    const [floorNo, setFloorNo] = useState("");
    const [street, setStreetName] = useState("");
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [unitNo, setUnitNo] = useState("");
    const [streetNo, setStreetNo] = useState("");
    const [isTimeSlot, setIsTimeSlot] = useState(false);
    const [hospital, setHospital] = useState("");
    const [building, setBuilding] = useState("");
    const [wardNo, setWardNo] = useState("");
    const [BedNo, setBedNo] = useState("");
    const [instruction, setinstruction] = useState("");
    const [cancellationDetails, setCancellationDetails] = useState("");
    const [showCanelPopup, setCancelPopup] = useState(false);
    const [showCancelFailPopup, setCancelFailPopup] = useState(false);
    const [scheduled, setScheduled] = useState(false);
    const [booking, setBooking] = useState(false);
    const [schedulingAppointment, setSchedulingAppointment] = useState(false);
    const [bookingLoading, setBookingLoading] = useState(false);
    const [indexDatePair, setIndexDatePair] = useState(0);
    const [shouldUpdate, setShouldUpdate] = useState(false);
    const [slotsBooked, setSlotsBooked] = useState<any>([]);
    const [appointmentConfirmed, setappointmentConfirmed] = useState(false);
    const [progressWidth, setprogressWidth] = useState(0);
    const [cardAdded, setCardAdded] = useState(false);
    const [showPaymentMethods, setShowPaymentMethods] = useState(false);
    const [slotTaken, setSlotTaken] = useState(false);
    const [emailSuccess, setEmailSuccess] = useState(false);
    const [cardInfo, setCardInfo] = useState({
      number: "",
      icon: "",
    });
    const [tokenreq, setTokenReq] = useState<any>({});
    const [cityData, setCityData] = useState<any[]>([]);
    const [suburbData, setSuburbData] = useState([]);
    const autoCompleteValue =
      suburb && stateMY && postalCode
        ? suburb + ", " + stateMY + ", " + postalCode
        : "";

    const lat = crData?.address?.[0]?.lat;
    const long = crData?.address?.[0]?.long;

    useEffect(() => {
      if (isAU) {
        Api.GET(
          CITY_STATES_API,
          ({ data }: any) => {
            setCityData(data?.data?.cities);
          },
          true,
          true,
          true
        );
      }
    }, []);
    useEffect(() => {
      if (isAU && city && cityData.length > 0) {
        const cityId = cityData?.find((ele: any) => ele.region_name === city);
        Api.GET(
          getSuburbStatePostcode(cityId?._id ?? ""),
          ({ data }: any) => {
            setSuburbData(data?.data?.suburb_state_postcode);
          },
          true,
          true,
          true
        );
      }
    }, [city, cityData]); // so to fetch different dropdown data on selecting different cities

    // Disable the "pay themselves" button when selected time slot is less than 5 hours
    // Also take care of the timezone when computing lead time
    let payThemselvesDisabled = false;
    const slotChosen = slotsBooked[0];
    if (slotChosen) {
      const date = slotChosen.item; // "2021-05-20"
      const selectedSlot = slotChosen.slot; // "3:00 PM - 4:00 PM"

      const dateObj = timeStringToDate(
        selectedSlot.split(" - ")[0],
        toYYYYMMDD(date) // copy the time to this date
      );

      if (dateObj) {
        const currentDate = new Date();
        const leadTimeInHrs =
          dateDiffHours(dateObj, currentDate, false) -
          destOffsetInMillis() / 3.6e6;
        payThemselvesDisabled = leadTimeInHrs < 5;
      }
    }

    useEffect(() => {
      const wallet = props.wallet;
      if (
        wallet &&
        wallet.card &&
        wallet.card.end_with &&
        wallet.card.card_icon
      ) {
        setCardAdded(true);
        setCardInfo({
          number: wallet.card.end_with,
          icon: wallet.card.card_icon,
        });
      }
    }, [props.wallet]);

    useEffect(() => {
      if (stateMY) {
        setdistrictDropdown(
          states.find((state: any) => state.name === stateMY)?.districts
        );
      } else {
        setdistrictDropdown([]);
      }
      setDistrictMY("");
    }, [stateMY, states]);

    useEffect(() => {
      setstatesDropDown(states.map((state: any) => state.name));
    }, [states]);

    const addIndexPair = () => {
      const slots: any[] = [];
      if (!_.isEmpty(dates)) {
        dates.slots.forEach((item: any) => {
          item.time_slots.forEach((obj: any) => {
            slots.push(obj);
          });
        });
      }
      if (indexDatePair + 1 < slots.length / 4) {
        setIndexDatePair(indexDatePair + 1);
      }
    };

    const removeIndexPair = () => {
      if (indexDatePair > 0) {
        setIndexDatePair(indexDatePair - 1);
      }
    };
    const onDateChange = (date: any) => {
      if (!date) {
        setDob(null);
      }
      if (date && !isNaN(date.getTime())) {
        const yr = date.getFullYear();
        if (yr >= minDate!.getFullYear() && yr <= maxDate!.getFullYear()) {
          setDob(date);
        }
      }
    };
    const onLanguageChange = (a: string) => {
      if (selectSpokenLanguages.includes(a)) {
        const index = selectSpokenLanguages.indexOf(a);
        if (index !== -1) {
          const data = [...selectSpokenLanguages];
          data.splice(index, 1);
          setselectSpokenLanguages(data);
        }
      } else {
        setselectSpokenLanguages([...selectSpokenLanguages, a]);
      }
    };

    useEffect(() => {
      if (isInitialMount.current) {
        isInitialMount.current = false;
      } else {
        if (!othersText) tagInput.current.focus();
      }
    }, [othersText]);

    useEffect(() => {
      if (shouldUpdate) {
        setShouldUpdate(false);
        const slots: any[] = [];
        let index = 0;
        let temp = false;
        let tempIndex = 0;

        if (!_.isEmpty(dates)) {
          dates.slots.forEach((item: any) => {
            item.time_slots.forEach((obj: any) => {
              slots.push(obj);
              index += 1;
              if (item.month === selectedMonth) {
                if (temp === false) {
                  temp = true;
                  tempIndex = Math.floor(index / 4);
                }
              }
            });
          });
        }
        setIndexDatePair(tempIndex);
      }
    }, [selectedMonth, shouldUpdate, dates]);

    useEffect(() => {
      const slots: any[] = [];
      let date: any;
      if (!_.isEmpty(dates)) {
        dates.slots.forEach((item: any) => {
          item.time_slots.forEach((obj: any) => {
            slots.push(obj);
          });
        });
        const pair = slots.slice(indexDatePair * 4, indexDatePair * 4 + 4);
        setPair(pair);
        date = pair[0]?.day;
      }
      if (!_.isEmpty(dates)) {
        dates.slots.forEach((item: any) => {
          item.time_slots.forEach((obj: any) => {
            if (date === obj.day) {
              const month = item.month;
              if (month !== selectedMonth) {
                handleChangeSelect("selectedMonth")(month);
              }
            }
          });
        });
      }
    }, [indexDatePair, dates, selectedMonth, handleChangeSelect]);

    useEffect(() => {
      setFirstName(crData.first_name);
      setLastName(crData.last_name);
      setselectSpokenLanguages(crData.language_preference ?? []);
      setOtherLanguage(crData.others_language_preference ?? "");
      setPrevDisease(crData?.ipca?.previous_infection);
      setDiseaseDetails(crData?.ipca?.infection_details ?? "");
      setinstruction(crData?.ipca?.special_instructions ?? "");

      if (crData.approximate_age) {
        setAge(crData.approximate_age);
      } else if (crData.dob) {
        if (isAU) {
          setDob(
            crData.dob ? crData.dob.split("/")?.reverse()?.join("/") : null
          );
        } else {
          const calage = String(calculateAge(dateDobFormat(crData.dob)));
          if (calage) {
            setAge(calage);
          }
        }
      }
      handleChangeSelect("title")(crData.salutation);
      try {
        if (crData.address[0].country === "Malaysia") {
          getStates();
          setTimeout(() => {
            setDistrictMY(crData.address[0].district);
          }, 1000);
        }
      } catch (e) { }
      try {
        setStateMY(crData.address[0].state ?? "");
        setStreetNo(crData.address[0].street_number);
        setUnitNo(crData.address[0].unit_number);
        setStreetName(crData.address[0].street_name);
        setLongitude(crData.address[0].long);
        setLatitude(crData.address[0].lat);
        setPostalCode(crData.address[0].postcode);
        setBldNo(crData.address[0].block_number);
        setSuburb(crData.address[0].suburb);
        if (crData.address[0].city) setCity(crData.address[0].city);

        if (crData.address[0].name === "Facility") {
          setFacility(true);
        } else {
          setFacility(false);
        }
      } catch (err) { }
    }, [crData, handleChangeSelect, getStates]);

    // refresh data when component loads
    useEffect(() => {
      refreshCareownerData();
    }, [refreshCareownerData]);

    const onGeocodeLoad = (loader: any, searchQuery: string) =>
      loader.load().then(() => {
        const geocoder = new win.google.maps.Geocoder();
        geocoder.geocode(
          { address: searchQuery },
          function (results: any, status: any) {
            if (status === "OK") {
              showLoading(false);
              setLongitude(results?.[0]?.geometry?.location?.lng() ?? "");
              setLatitude(results?.[0]?.geometry?.location?.lat() ?? "");
            }
            showLoading(false);
          }
        );
      });
    const onPlaceSelect = useCallback((place: any) => {
      const suburbValue: any = {};
      let searchQuery = "";
      for (let i = 0; i < place.length; i++) {
        const type = place[i].types[0];
        const name = place[i].long_name || "";
        searchQuery += ", " + name;
        if (type === "street_number") {
          isAU ? setStreetNo(name) : setBldNo(name);
        } else if (type === "route") {
          setStreetName(name);
        } else if (type === "locality") {
          suburbValue.suburb = name;
        } else if (type === "administrative_area_level_1") {
          suburbValue.state = place[i].short_name || "";
        } else if (type === "postal_code") {
          suburbValue.postal_code = name;
          setPostalCode(name);
        } else if (type === GoogleLocationType.COLLOQUIAL_AREA) {
          setCity(name);
        }
      }
      searchQuery += ", " + APP_COUNTRY;
      const loader = new Loader({
        // @ts-ignore
        apiKey: process.env.REACT_APP_GEOCODING_KEY,
        id: "__googleMapsScriptId",
        version: "weekly",
        libraries: ["places"],
      });

      onGeocodeLoad(loader, searchQuery);
      if (Object.keys(suburbValue).length === 3) {
        const autoCompleteVal =
          suburbValue.suburb +
          ", " +
          suburbValue.state +
          ", " +
          suburbValue.postal_code;
      }
      setInputFill(true);
    }, []);

    const updateMonth = (month: string) => {
      setShouldUpdate(true);
      handleChangeSelect("selectedMonth")(month);
    };

    const checkBooked = (slot: string, item: any) => {
      for (let i = 0; i < slotsBooked.length; i++) {
        if (slotsBooked[i].slot === slot && slotsBooked[i].item === item.day) {
          return true;
        }
      }
      return false;
    };

    const CancelAppointment = () => {
      Api.POST(
        `care-recipient/ipca/cancel`,
        {
          cr_id: crData.id,
          reason_for_cancellation: cancellationDetails,
        },
        (resp?: any) => {
          if (resp?.data?.data?.success) {
            setCancelPopup(true);
          } else if (!resp?.data?.data?.success) {
            setCancelFailPopup(true);
          }
        },
        true,
        true,
        true
      );
    };

    const ToggleSlot = (slot: string, item: any) => {
      const obj = { slot: slot, item: item.day };
      let temp = true;
      const newarr: any = [];
      for (let i = 0; i < slotsBooked.length; i++) {
        if (slotsBooked[i].item === item.day && slot === slotsBooked[i].slot) {
          temp = false;
        }
      }
      if (temp) {
        newarr.push(obj);
      }
      setSlotsBooked(newarr);
    };
    useEffect(() => {
      if (prevDisease && !diseaseDetail) {
        setIsTimeSlot(false);
        return;
      }
      if (selectSpokenLanguages.includes(OTHERS) && !otherLanguage) {
        setIsTimeSlot(false);
        return;
      }

      if (facility) {
        if (
          title &&
          (isAU || bldNo) &&
          street &&
          wardNo &&
          hospital &&
          floorNo &&
          postalCode
        ) {
          setIsTimeSlot(true);
        } else {
          setIsTimeSlot(false);
        }
      } else {
        if (
          title &&
          firstName &&
          lastName &&
          (isAU || age) &&
          (isAU || bldNo) &&
          street &&
          postalCode
        ) {
          if (isSG) {
            setIsTimeSlot(true);
          } else if (isAU) {
            dob ? setIsTimeSlot(true) : setIsTimeSlot(false);
          } else if (isMY) {
            if (stateMY && districtMY) {
              setIsTimeSlot(true);
            } else {
              setIsTimeSlot(false);
            }
          }
        } else {
          setIsTimeSlot(false);
        }
      }
    }, [
      title,
      firstName,
      lastName,
      age,
      dob,
      bldNo,
      street,
      BedNo,
      unitNo,
      wardNo,
      facility,
      hospital,
      building,
      floorNo,
      stateMY,
      districtMY,
      prevDisease,
      diseaseDetail,
      postalCode,
      selectSpokenLanguages,
      otherLanguage,
    ]);

    const confirmBooking = () => {
      setappointmentConfirmed(true);
    };

    const confirmingBooking = () => {
      if (parentState.updateAppointment) {
        if (!cardInfo.number) {
          setShowPaymentMethods(true);
          return;
        }
        const ReqObj = {
          cr_id: dates.cr_id,
          day: slotsBooked[0].item,
          time: slotsBooked[0].slot,
          payment_method:
            "existing card" /* on "in app" or "on call" or "existing card" */,
        };
        setBookingLoading(true);
        setSchedulingAppointment(true);
        Api.POST(
          `care-recipient/ipca/book`,
          ReqObj,
          (resp?: any) => {
            if (resp) {
              setprogressWidth(100);
              confirmBooking();
              setBookingLoading(false);
              setSchedulingAppointment(false);
            } else {
              setBookingLoading(false);
              setSchedulingAppointment(false);
            }
          },
          true,
          true,
          true
        );
      } else if (cardInfo.number && cardAdded) {
        const ReqObj = {
          cr_id: dates.cr_id,
          day: slotsBooked[0].item,
          time: slotsBooked[0].slot,
          payment_method:
            "existing card" /* on "in app" or "on call" or "existing card" */,
        };
        setBookingLoading(true);
        setSchedulingAppointment(true);
        Api.POST(
          `care-recipient/ipca/book`,
          ReqObj,
          (resp?: any) => {
            if (resp) {
              setprogressWidth(100);
              confirmBooking();
              setBookingLoading(false);
              setSchedulingAppointment(false);
            } else {
              setBookingLoading(false);
              setSchedulingAppointment(false);
            }
          },
          true,
          true,
          true
        );
      } else {
        const ReqObj = tokenreq;
        if (ReqObj) {
          setBookingLoading(true);
          setSchedulingAppointment(true);
          Api.POST(
            `care-recipient/ipca/book`,
            ReqObj,
            (resp?: any) => {
              if (resp) {
                setprogressWidth(100);
                confirmBooking();
                setBookingLoading(false);
                setSchedulingAppointment(false);
              } else {
                setBookingLoading(false);
                setSchedulingAppointment(false);
              }
            },
            true,
            true,
            true
          );
        }
      }
    };

    const checkTimeSlots = () => {
      let ReqObj: any = {};
      if (!facility) {
        ReqObj = {
          cr_id: crData.id,
          co_id: props.match.params.id /* mandatory field */,
          get_timeslot:
            true /* we won't return timeslot if this is false, so this would be faster. use this when auto saving */,
          salutation: title,
          first_name: firstName,
          last_name: lastName,
          spoken_languages: selectSpokenLanguages,
          have_infectious_diseases: prevDisease,
          address: {
            type: "Home", // or "Facility"
            street_name: street,
            postcode: postalCode,
          },
        };
        if (unitNo && !isAU) {
          ReqObj["address"]["unit_number"] = unitNo;
        }

        if (suburb) {
          ReqObj["address"]["suburb"] = suburb;
        }
        if (city) {
          ReqObj["address"]["city"] = city;
        }
      } else {
        ReqObj = {
          cr_id: crData.id,
          co_id: props.match.params.id /* mandatory field */,
          get_timeslot:
            true /* we won't return timeslot if this is false, so this would be faster. use this when auto saving */,
          salutation: title,
          first_name: firstName,
          last_name: lastName,
          dob: dateDobFormat(dob as any) /* dd/mm/yyyy */,

          spoken_languages: selectSpokenLanguages,
          have_infectious_diseases: prevDisease,
          address: {
            type: "Facility", // or "Facility"
            facility_name: hospital, // for Facility address only
            ward: wardNo, // for Facility address only
            bed: BedNo, // for Facility address only
            floor_number: floorNo, // for Facility address only
            street_name: street,
            postcode: postalCode,
          },
        };
        if (building) {
          ReqObj["address"]["building_name"] = building;
        }
      }
      if (streetNo && isAU) {
        ReqObj["address"]["street_number"] = streetNo;
      }
      if (unitNo && isAU) {
        ReqObj["address"]["unit_number"] = unitNo;
      }
      if (bldNo) {
        ReqObj["address"]["block_number"] = bldNo; // same as building number
      }
      const address = ReqObj["address"];
      address["country"] = APP_COUNTRY;

      if (isMY) {
        address["state"] = stateMY;
        address["district"] = districtMY;
      } else if (isAU) {
        address["state"] = stateMY;
        address["suburb"] = suburb;
        address["city"] = city;
      }

      if (instruction) {
        ReqObj["special_instructions"] = instruction;
      }
      if (otherLanguage) {
        ReqObj["other_spoken_languages"] = otherLanguage;
      }
      if (prevDisease) {
        ReqObj["infectious_diseases"] = diseaseDetail;
      }
      if (age) {
        ReqObj["age"] = age;
      }
      if (dob) {
        ReqObj["dob"] = dateDobFormat(dob as any);
      }
      Api.POST(
        `care-recipient/ipca/slots`,
        ReqObj,
        (resp?: any) => {
          if (resp) {
            const data = resp && resp.data;
            if (data) {
              setDates(data);
              setIndexDatePair(0);
              setScheduled(true);
              const months: string[] = [];
              for (let i = 0; i < data.slots.length; i++) {
                months.push(data.slots[i].month);
              }
              setMonthDropDown(months);
            }
          }
        },
        true,
        true,
        true
      );
    };

    const getCardInfo = (method: string) => {
      setShowPaymentMethods(false);
      if (method === "Weblink") {
        const ReqObj = {
          cr_id: dates.cr_id,
          day: slotsBooked[0].item,
          time: slotsBooked[0].slot,
          payment_method:
            "weblink" /* on "in app" or "on call" or "existing card" */,
        };
        try {
          Api.POST(
            `care-recipient/ipca/book`,
            ReqObj,
            (resp?: any) => {
              if (resp) {
                setEmailSuccess(true);
              } else {
                setSlotTaken(true);
              }
            },
            true,
            false,
            false
          );
        } catch (err) {
          console.log(err);
        }
      } else if (method === "in app") {
        const ReqObj = {
          cr_id: dates.cr_id,
          day: slotsBooked[0].item,
          time: slotsBooked[0].slot,
          payment_method:
            "in app" /* on "in app" or "on call" or "existing card" */,
        };
        try {
          Api.POST(
            `care-recipient/ipca/book`,
            ReqObj,
            (resp?: any) => {
              if (resp) {
                setEmailSuccess(true);
              } else {
                setSlotTaken(true);
              }
            },
            true,
            false,
            false
          );
        } catch (err) {
          console.log(err);
        }
      } else if (method === "on call") {
        setBooking(true);
      }
    };

    const handleNextPayment = () => {
      if (parentState.updateAppointment) {
        confirmingBooking();
        return;
      }
      if (cardAdded) {
        setBooking(true);
      } else {
        setShowPaymentMethods(true);
      }
    };

    const BookWithCard = (res: any) => {
      setCardAdded(false);
      const ReqObj = {
        cr_id: dates.cr_id,
        day: slotsBooked[0].item,
        time: slotsBooked[0].slot,
        payment_method: "on call",
        stripe_token: res.token.id,
      };
      setTokenReq(ReqObj);

      if (res.token && res.token.card && res.token.card.brand) {
        const brand = res.token.card.brand;
        if (brand) {
          setCardInfo({
            number: res.token.card.last4,
            icon: getCardIcon(brand),
          });
        } else {
          setCardInfo({
            number: res.token.card.last4,
            icon: getCardIcon("Unknown"),
          });
        }
      }
    };
    const handleAutocompleteChange = (value: string | null) => {
      const [newSuburb, newState, newPostalCode] = value
        ? value.split(", ") // comma with space--important
        : [];
      setSuburb(newSuburb);
      setPostalCode(newPostalCode);
      setStateMY(newState);
    };

    const enableSavebtn = () => {
      if (!latitude && !longitude) {
        return " app-save-btn-enable";
      }
      return " disable-save-address-btn";
    };
    const onSaveAddress = async () => {
      try {
        showLoading(true);
        const searchQuery =
          unitNo?.split(" ").join("+") + //asa
          ", " +
          bldNo?.split(" ").join("+") +
          ", " +
          streetNo?.split(" ").join("+") +
          ", " +
          street?.split(" ").join("+") +
          ", " +
          suburb?.split(" ").join("+") +
          ", " +
          stateMY?.split(" ").join("+") +
          ", " +
          postalCode?.split(" ").join("+") +
          ", " +
          city?.split(" ").join("+") +
          ", " +
          APP_COUNTRY;

        const loader = new Loader({
          // @ts-ignore
          apiKey: process.env.REACT_APP_GEOCODING_KEY,
          id: "__googleMapsScriptId",
          version: "weekly",
          libraries: ["places"],
        });
        loader.load().then(() => {
          const geocoder = new win.google.maps.Geocoder();
          geocoder.geocode(
            { address: searchQuery },
            function (results: any, status: any) {
              if (status === "OK") {
                showLoading(false);
                setLongitude(results?.[0]?.geometry?.location?.lng() ?? "");
                setLatitude(results?.[0]?.geometry?.location?.lat() ?? "");
              }
              showLoading(false);
            }
          );
        });
      } catch (error) {
        console.log("error", error);
        showLoading(false);
      }
    };
    return (
      <>
        {appointmentConfirmed && (
          <PortalDialog className="ha-dialog ha-dialog-appear ipca-ac-dial">
            <div className="vs-dialog-close-container ipca-float-r">
              <div className="small-icon ipca-icon-container">
                <IconButton
                  className="vs-dialog-close"
                  onClick={async () => {
                    await updateCRData();
                    refreshCareownerData();

                    setScheduled(false);
                    setappointmentConfirmed(false);
                    parentSetState({ ...parentState, scheduleIpca: false });
                  }}
                  aria-label="close"
                >
                  <Close />
                </IconButton>
              </div>
            </div>
            <div>
              <img
                alt=""
                className="ipca-img-app-confirm"
                height={136}
                src="/self-serve/appointment-confirm-grphic@3x.png"
              />
              <img
                className="ipca-filled-confirmed"
                src="/self-serve/filled-done@3x.png"
                alt=""
                height={34}
              />
              <span className="scheduling-your-appo ">
                Appointment{" "}
                {parentState.updateAppointment ? "updated" : "confirmed"}
              </span>
              <div className="we-have-informed-the">
                We have informed the Care Specialist assigned and blocked the
                date on their calendar. This will also trigger an email and push
                notification to the customer.
              </div>
            </div>
          </PortalDialog>
        )}
        {showCanelPopup && (
          <PortalDialog className="ha-dialog ha-dialog-appear ipca-cancel-dial">
            <div className="vs-dialog-close-container ipca-float-r">
              <div className="small-icon ipca-icon-container">
                <IconButton
                  className="vs-dialog-close"
                  onClick={async () => {
                    // await updateCRData();
                    refreshCareownerData();
                    // setScheduled(false);
                    setCancelPopup(false);
                    // setappointmentConfirmed(false);
                    parentSetState({
                      ...parentState,
                      showCancelAppointment: false,
                      scheduleIpca: false,
                    });
                  }}
                  aria-label="close"
                >
                  <Close />
                </IconButton>
              </div>
            </div>
            <div>
              <img
                alt=""
                height={146}
                className="ipca-img-app-confirm"
                src="/self-serve/cancel-ipca@3x.png"
              />
              <span className="scheduling-your-appo ">
                Appointment cancelled!
              </span>
              <div className="we-have-informed-the">
                We have cancelled the IPCA and released the slot for future
                bookings. Please inform the customer accordingly.
              </div>
            </div>
          </PortalDialog>
        )}

        {showCancelFailPopup && (
          <PortalDialog className="ha-dialog ha-dialog-appear ipca-cancel-dial">
            <div className="vs-dialog-close-container ipca-float-r">
              <div className="small-icon ipca-icon-container">
                <IconButton
                  className="vs-dialog-close"
                  onClick={() => setCancelFailPopup(false)}
                  aria-label="close"
                >
                  <Close />
                </IconButton>
              </div>
            </div>
            <div>
              <img
                alt=""
                height={146}
                className="ipca-img-app-confirm"
                src="/self-serve/cancel-fail@3x.png"
              />
              <span className="scheduling-your-appo ">
                Cancellation failed!
              </span>
              <div className="we-have-informed-the">
                Sorry, IPCA session is failed to cancel. Please try again.
              </div>
            </div>
          </PortalDialog>
        )}

        <Div
          className="vs-general-info-div center mr-8 flex-b ipca-calc-w"
          bg={"#ebeff5"}
        >
          <div>
            <img
              alt=""
              className="middle ml-12"
              height={28}
              src="/self-serve/ic_ipca@3x.png"
            />
            <span className="ipca-status middle ml-2">IPCA Status</span>
            <span className="vs-general-info middle">
              {parentState.showCancelAppointment
                ? "Cancel Appointment"
                : parentState.updateAppointment
                  ? "Change Appointment"
                  : "Scheduling…"}
            </span>
          </div>
          <div
            onClick={() =>
              parentSetState({ ...parentState, scheduleIpca: false })
            }
            className="mr-20 pointer flex center"
          >
            <img
              alt=""
              className="middle"
              height={20}
              src="/self-serve/cancel@3x.png"
            />
            <span className="cancel middle">Cancel</span>
          </div>
        </Div>
        {parentState.showCancelAppointment && (
          <>
            <div className="co-custom-box mr-8">
              <div className="co-header-element p-0 flex justify-between">
                <Div
                  pl={24}
                  className={
                    collapse
                      ? "co-header-element flex justify-between bg-transparent"
                      : "co-header-element flex justify-between"
                  }
                >
                  <div className="flex align-center">
                    <span className="ipca-img-bottom-align ipca-h-72">
                      <img
                        src="/self-serve/img_IPCAcancelled@3x.png"
                        alt=""
                        height={71}
                        width={82}
                      />
                    </span>
                    <div className="co-general-text ml-8">
                      Cancellation Details
                    </div>
                  </div>
                </Div>
              </div>
              <div className="co-inner-container pb-1">
                <div className="flex ipca-m-t-30">
                  <img alt="" height={32} src="/self-serve/service@3x.png" />
                  <Txt className="ipca-reason-cancel" color={"#22234E"} fs={18}>
                    Reason for Cancellation
                  </Txt>
                </div>
                <div className="ipca-text-cancel-detail">
                  <textarea
                    value={cancellationDetails}
                    onChange={(e) => setCancellationDetails(e.target.value)}
                    className="instruction"
                    placeholder="e.g. The CR admitted to hospital due to a fall at home."
                  />
                </div>
              </div>
            </div>
            <div className="flex justify-end mt-8">
              <button
                onClick={CancelAppointment}
                disabled={cancellationDetails ? false : true}
                className={
                  cancellationDetails
                    ? "time-slot time-slot2 ipca-m-r-40px"
                    : "time-slot ipca-m-r-40px"
                }
              >
                Confirm Cancellation
              </button>
            </div>
          </>
        )}
        {!parentState.showCancelAppointment && (
          <>
            {!scheduled ? (
              <div className="mr-8 ipca-m-t-20">
                <Div
                  pl={16}
                  className={
                    collapse
                      ? "co-header-element flex justify-between bg-transparent ipca-p-l-23"
                      : "co-header-element flex justify-between ipca-p-l-23"
                  }
                >
                  <div className="flex align-center">
                    <span className="ipca-img-bottom-align ipca-h-72">
                      <img
                        src="/self-serve/assessment@3x.png"
                        alt=""
                        height={63}
                        width={82}
                      />
                    </span>
                    <div className="co-general-text ml-8">
                      Assessment Booking Info
                    </div>
                  </div>
                </Div>
                <div className="flex justify-between ipca-assesment-div">
                  <div className="ipca-50-left-side">
                    <div className="flex">
                      <img
                        alt=""
                        height={32}
                        src="/self-serve/cr-info@3x.png"
                      />
                      <span className="ipca-care-info">
                        Care Recipient Information
                      </span>
                    </div>
                    <div className="flex ipca-m-t-20 ipca-flex-wrap">
                      <div className="flex ipca-w-100">
                        <div className="ipca-flex-1 ">
                          <SimpleSelect
                            value={title}
                            label="Title"
                            dropdownData={titleDropdown}
                            validate={validate}
                            onChange={handleChangeSelect("title")}
                          />
                        </div>
                        <TextField
                          className="ipca-flex-2 ipca-m-l-8px"
                          label="First Name"
                          error={validate && !firstName}
                          variant="outlined"
                          value={firstName}
                          onChange={(e: any) => setFirstName(e.target.value)}
                        />
                        <TextField
                          className="ipca-flex-2 ipca-m-l-8px"
                          label="Last Name"
                          error={validate && !lastName}
                          variant="outlined"
                          value={lastName}
                          onChange={(e: any) => setLastName(e.target.value)}
                        />
                      </div>
                      {isAU ? (
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            id="dob"
                            autoOk
                            type="tel"
                            className="mt-4"
                            inputVariant="outlined"
                            disableFuture
                            openTo="year"
                            format="dd/MM/yyyy"
                            label="Date of birth"
                            views={["year", "month", "date"]}
                            value={dob}
                            placeholder="DD/MM/YYYY"
                            clearable
                            onChange={onDateChange}
                            keyboardIcon={
                              <img
                                src="/self-serve/ic_calendar@3x.png"
                                alt=""
                                width="23.14"
                                height="24"
                              />
                            }
                          />
                        </MuiPickersUtilsProvider>
                      ) : (
                        <TextField
                          className={"helper-text-right ipca-min-w-164"}
                          label="Age"
                          type="number"
                          variant="outlined"
                          error={validate && !age}
                          value={age}
                          helperText="years old"
                          onChange={(e: any) => {
                            const a = e.target.value.replace(
                              /[^0123456789.]/g,
                              ""
                            );
                            a && setAge(a);
                          }}
                        />
                      )}
                    </div>
                    <div className="bold ipca-m-t-20">Spoken Languages</div>

                    <div className="flex mt-6 align-center ipca-w-421">
                      <div className="flex wrap align-center">
                        {languageDropdown.map((mc: string) => (
                          <div
                            className="fs-14 co-greyish ipca-mr-5px ipca-m-b-10"
                            key={mc}
                          >
                            <div
                              className="co-med-tag curson-pointer"
                              data-selected={_attr(
                                selectSpokenLanguages.indexOf(mc) > -1
                              )}
                              onClick={() => onLanguageChange(mc)}
                            >
                              {mc}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    {selectSpokenLanguages.includes(OTHERS) && (
                      <div className="mt-2 ipca-infectious">
                        <TextField
                          id="outlined-multiline-static"
                          className="ipca-w-246 ipca-textarea"
                          label="Other Languages"
                          value={otherLanguage}
                          onChange={(e: any) =>
                            setOtherLanguage(e.target.value)
                          }
                          variant="outlined"
                        />
                      </div>
                    )}
                    <div className="w-full">
                      <div className="flex">
                        <div className="bold mt-3 mr-4">
                          Any recent or previous infections?
                        </div>
                        <div>
                          <span className="mr-2 co-main-color fs-14">
                            {prevDisease ? "YES" : "NO"}
                          </span>
                          <span>
                            <FormControlLabel
                              control={
                                <IOSSwitch
                                  // @ts-ignore
                                  checked={prevDisease}
                                  onChange={() => setPrevDisease(!prevDisease)}
                                />
                              }
                              label=""
                            />
                          </span>
                        </div>
                      </div>
                      {prevDisease && (
                        <div className="mt-2 ipca-infectious">
                          <TextField
                            id="outlined-multiline-static"
                            className="w-full ipca-textarea"
                            placeholder="Please specify what is the infection, the date of diagnosis and the severity."
                            multiline
                            rows={2}
                            value={diseaseDetail}
                            onChange={(e: any) =>
                              setDiseaseDetails(e.target.value)
                            }
                            variant="outlined"
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="ipca-50-right-side">
                    <div className="flex">
                      <img
                        alt=""
                        height={32}
                        src="/self-serve/assessment-location@3x.png"
                      />
                      <span className="ipca-care-info">
                        Assessment Location
                      </span>
                    </div>
                    <Div className="flex" mt={18}>
                      <button
                        onClick={() => setFacility(false)}
                        className={!facility ? "home" : "facility"}
                      >
                        Home
                      </button>
                      <button
                        onClick={() => setFacility(true)}
                        className={facility ? "home ml-12" : "facility ml-12"}
                      >
                        Hospital/Facility
                      </button>
                    </Div>
                    <div className="ipca-search-div-assesment">
                      <div className="co-popup-search-box">
                        <GoogleAutocomplete
                          inputRef={input}
                          onPlaceChange={onPlaceSelect}
                        >
                          <input
                            ref={input}
                            type="text"
                            autoComplete="s"
                            className={
                              inputFill
                                ? "co-popup-search-inp co-changeIndent"
                                : "co-popup-search-inp"
                            }
                            placeholder="Search Location"
                          />
                        </GoogleAutocomplete>
                        <img
                          src="/self-serve/ic_search@3x.png"
                          alt=""
                          className="co-ar-search-ico ipca-t-14"
                          height={26}
                          width={26}
                        />
                      </div>
                    </div>

                    {!facility ? (
                      <div>
                        <div className="flex">
                          {isAU ? (
                            <>
                              <TextField
                                className="ipca-flex-2 ipca-m-t-20"
                                label="Unit No. /Building Name"
                                variant="outlined"
                                error={validate && !unitNo}
                                value={unitNo ? unitNo : ""}
                                onChange={(e: any) => setUnitNo(e.target.value)}
                              />
                              <TextField
                                className="ipca-flex-1 ipca-m-t-20 ipca-m-l-8px"
                                label="Street No."
                                error={validate && !streetNo}
                                variant="outlined"
                                value={streetNo ? streetNo : ""}
                                onChange={(e: any) =>
                                  setStreetNo(e.target.value)
                                }
                              />
                            </>
                          ) : (
                            <>
                              <TextField
                                className="ipca-flex-1 ipca-m-t-20"
                                label="Building No."
                                variant="outlined"
                                error={validate && !bldNo}
                                value={bldNo ? bldNo : ""}
                                onChange={(e: any) => setBldNo(e.target.value)}
                              />
                              <TextField
                                className="ipca-flex-1 ipca-m-t-20 ipca-m-l-8px"
                                label="Unit No."
                                error={validate && !unitNo}
                                variant="outlined"
                                value={unitNo ? unitNo : ""}
                                onChange={(e: any) => setUnitNo(e.target.value)}
                              />
                            </>
                          )}

                          <TextField
                            className="ipca-flex-2 ipca-m-t-20 ipca-m-l-8px"
                            label="Street Name"
                            variant="outlined"
                            error={validate && !street}
                            value={street ? street : ""}
                            onChange={(e: any) => setStreetName(e.target.value)}
                          />
                        </div>
                        {isAU && (
                          <div className="flex">
                            <div className="autocomplete mt-1">
                              <span className="ipca-flex-1 ipca-m-t-20 ipca-m-l-8px">
                                <Autocomplete
                                  id="combo-box-demo"
                                  options={suburbData}
                                  value={autoCompleteValue}
                                  onChange={(event, newValue) => {
                                    handleAutocompleteChange(newValue);
                                  }}
                                  getOptionLabel={(option: any) => option}
                                  style={{ width: 333 }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: "none",
                                      }}
                                      label="Suburb/ State/ Postcode"
                                      variant="outlined"
                                    />
                                  )}
                                />
                              </span>
                            </div>

                            <span className="ipca-flex-1 ipca-m-t-20 ipca-m-l-8px">
                              <SimpleSelect
                                value={city ? city : ""}
                                label="City"
                                dropdownData={cityData?.map(
                                  (ele: any) => ele.region_name
                                )}
                                onChange={(e: any) => e && setCity(e)}
                              />
                            </span>
                          </div>
                        )}
                        {isMY && (
                          <div className="flex">
                            <span className="ipca-flex-1 ipca-m-t-20">
                              <SimpleSelect
                                value={stateMY ? stateMY : ""}
                                label="State"
                                dropdownData={statesDropDown}
                                validate={validate}
                                onChange={(e: any) => setStateMY(e)}
                              />
                            </span>

                            <span className="ipca-flex-1 ipca-m-t-20 ipca-m-l-8px">
                              <SimpleSelect
                                value={districtMY ? districtMY : ""}
                                label="Area"
                                dropdownData={districtDropdown}
                                validate={validate}
                                onChange={(e: any) => setDistrictMY(e)}
                              />
                            </span>
                          </div>
                        )}
                        <div className="flex ipca-m-t-20">
                          {!isAU && (
                            <TextField
                              className="ipca-flex-1"
                              label="Postal Code"
                              variant="outlined"
                              error={validate && !postalCode}
                              value={postalCode ? postalCode : ""}
                              onChange={(e: any) =>
                                setPostalCode(e.target.value)
                              }
                            />
                          )}

                          <TextField
                            className="helper-text-top ipca-flex-1 ml-2"
                            label={APP_COUNTRY}
                            type="text"
                            variant="outlined"
                            value={""}
                            helperText="Country"
                            disabled
                          />
                          <div className="ipca-flex-2" />
                        </div>
                      </div>
                    ) : (
                      <div>
                        {isAU ? (
                          <div>
                            <div className="flex">
                              <TextField
                                className="ipca-flex-2 ipca-m-t-20 ipca"
                                label="Hospital/Facility Name"
                                error={validate && !hospital}
                                variant="outlined"
                                value={hospital ? hospital : ""}
                                onChange={(e: any) =>
                                  setHospital(e.target.value)
                                }
                              />
                              <TextField
                                className="ipca-flex-1 ipca-m-t-20 ipca-m-l-8px"
                                label="Floor No."
                                variant="outlined"
                                error={validate && !floorNo}
                                value={floorNo ? floorNo : ""}
                                onChange={(e: any) =>
                                  setFloorNo(e.target.value)
                                }
                              />
                              <TextField
                                className="ipca-flex-1 ipca-m-t-20 ipca-m-l-8px"
                                label="Ward/Room"
                                variant="outlined"
                                error={validate && !wardNo}
                                value={wardNo ? wardNo : ""}
                                onChange={(e: any) => setWardNo(e.target.value)}
                              />
                            </div>
                            <div className="flex">
                              <TextField
                                className="ipca-flex-1 ipca-m-t-20"
                                label="Bed No."
                                variant="outlined"
                                error={validate && !BedNo}
                                value={BedNo ? BedNo : ""}
                                onChange={(e: any) => setBedNo(e.target.value)}
                              />
                              <TextField
                                className={
                                  "ipca-flex-2 ipca-m-t-20 ipca-m-l-8px"
                                }
                                label="Unit No. /Building Name"
                                variant="outlined"
                                error={validate && !bldNo}
                                value={bldNo ? bldNo : ""}
                                onChange={(e: any) => setBldNo(e.target.value)}
                              />
                              <TextField
                                className="ipca-flex-1 ipca-m-t-20 ipca-m-l-8px"
                                label="Street No."
                                error={validate && !unitNo}
                                variant="outlined"
                                value={unitNo ? unitNo : ""}
                                onChange={(e: any) => setUnitNo(e.target.value)}
                              />
                            </div>
                            <div className="flex">
                              <TextField
                                className="ipca-flex-1 ipca-m-t-20 "
                                label="Street Name"
                                variant="outlined"
                                error={validate && !street}
                                value={street ? street : ""}
                                onChange={(e: any) =>
                                  setStreetName(e.target.value)
                                }
                              />
                              <div className="autocomplete mt-1 ipca-flex-1 ipca-m-l-8px">
                                <span className="ipca-flex-1 ipca-m-t-20 ipca-m-l-8px">
                                  <Autocomplete
                                    id="combo-box-demo"
                                    options={suburbData}
                                    value={autoCompleteValue}
                                    onChange={(event, newValue) => {
                                      handleAutocompleteChange(newValue);
                                    }}
                                    getOptionLabel={(option: any) => option}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        inputProps={{
                                          ...params.inputProps,
                                          autoComplete: "none",
                                        }}
                                        label="Suburb/ State/ Postcode"
                                        variant="outlined"
                                      />
                                    )}
                                  />
                                </span>
                              </div>
                            </div>
                            <div className="flex">
                              <span className="ipca-m-t-20">
                                <SimpleSelect
                                  value={city ? city : ""}
                                  label="City"
                                  dropdownData={cityData?.map(
                                    (ele: any) => ele.region_name
                                  )}
                                  onChange={(e: any) => e && setCity(e)}
                                />
                              </span>
                              <TextField
                                className=" helper-text-top ipca-m-t-20 ipca-m-l-8px"
                                label={APP_COUNTRY}
                                type="text"
                                variant="outlined"
                                value={""}
                                helperText="Country"
                                disabled
                              />
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div className="flex">
                              <TextField
                                className="ipca-flex-1 ipca-m-t-20 ipca"
                                label="Hospital/Facility Name"
                                error={validate && !hospital}
                                variant="outlined"
                                value={hospital ? hospital : ""}
                                onChange={(e: any) =>
                                  setHospital(e.target.value)
                                }
                              />
                              <TextField
                                className="ipca-flex-1 ipca-m-t-20 ipca-m-l-8px"
                                label="Building Name"
                                error={validate && !building}
                                variant="outlined"
                                value={building ? building : ""}
                                onChange={(e: any) =>
                                  setBuilding(e.target.value)
                                }
                              />
                            </div>
                            <div className="flex">
                              <TextField
                                className="ipca-flex-1 ipca-m-t-20"
                                label="Building No."
                                variant="outlined"
                                error={validate && !bldNo}
                                value={bldNo ? bldNo : ""}
                                onChange={(e: any) => setBldNo(e.target.value)}
                              />
                              <TextField
                                className="ipca-flex-1 ipca-m-t-20 ipca-m-l-8px"
                                label="Floor No."
                                variant="outlined"
                                error={validate && !floorNo}
                                value={floorNo ? floorNo : ""}
                                onChange={(e: any) =>
                                  setFloorNo(e.target.value)
                                }
                              />
                              <TextField
                                className="ipca-flex-1 ipca-m-t-20 ipca-m-l-8px"
                                label="Ward No."
                                variant="outlined"
                                error={validate && !wardNo}
                                value={wardNo ? wardNo : ""}
                                onChange={(e: any) => setWardNo(e.target.value)}
                              />
                              <TextField
                                className="ipca-flex-1 ipca-m-t-20 ipca-m-l-8px"
                                label="Bed No."
                                variant="outlined"
                                error={validate && !BedNo}
                                value={BedNo ? BedNo : ""}
                                onChange={(e: any) => setBedNo(e.target.value)}
                              />
                            </div>
                            {isSG && (
                              <div className="flex">
                                <TextField
                                  className="ipca-flex-2 ipca-m-t-20 "
                                  label="Street Name"
                                  variant="outlined"
                                  error={validate && !street}
                                  value={street ? street : ""}
                                  onChange={(e: any) =>
                                    setStreetName(e.target.value)
                                  }
                                />
                                <TextField
                                  className="ipca-flex-1 ipca-m-t-20 ipca-m-l-8px"
                                  label="Postal Code"
                                  variant="outlined"
                                  error={validate && !postalCode}
                                  value={postalCode ? postalCode : ""}
                                  onChange={(e: any) =>
                                    setPostalCode(e.target.value)
                                  }
                                />

                                <TextField
                                  className=" helper-text-top ipca-flex-1 ipca-m-t-20 ipca-m-l-8px"
                                  label={APP_COUNTRY}
                                  type="text"
                                  variant="outlined"
                                  value={""}
                                  helperText="Country"
                                  disabled
                                />
                              </div>
                            )}
                            {isMY && (
                              <>
                                <div className="flex">
                                  <TextField
                                    className="ipca-flex-1 ipca-m-t-20 "
                                    label="Street Name"
                                    variant="outlined"
                                    error={validate && !street}
                                    value={street ? street : ""}
                                    onChange={(e: any) =>
                                      setStreetName(e.target.value)
                                    }
                                  />

                                  <span className="ipca-flex-1 ipca-m-t-20 ipca-m-l-8px">
                                    <SimpleSelect
                                      value={stateMY ? stateMY : ""}
                                      label="State"
                                      dropdownData={statesDropDown}
                                      validate={validate}
                                      onChange={(e: any) => setStateMY(e)}
                                    />
                                  </span>
                                </div>
                                <div className="flex">
                                  {isMY && (
                                    <>
                                      <span className="ipca-flex-2 ipca-m-t-20">
                                        <SimpleSelect
                                          value={districtMY ? districtMY : ""}
                                          label="District"
                                          dropdownData={districtDropdown}
                                          validate={validate}
                                          onChange={(e: any) =>
                                            setDistrictMY(e)
                                          }
                                        />
                                      </span>
                                      <TextField
                                        className="ipca-flex-1 ipca-m-t-20 ipca-m-l-8px"
                                        label="Postal Code"
                                        variant="outlined"
                                        error={validate && !postalCode}
                                        value={postalCode ? postalCode : ""}
                                        onChange={(e: any) =>
                                          setPostalCode(e.target.value)
                                        }
                                      />

                                      <TextField
                                        className=" helper-text-top ipca-flex-1 ipca-m-t-20 ipca-m-l-8px"
                                        label={APP_COUNTRY}
                                        type="text"
                                        variant="outlined"
                                        value={""}
                                        helperText="Country"
                                        disabled
                                      />
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                    {/* Lat long fields */}
                    <Div className="flex center lat-long" mt={20}>
                      <Div
                        mt={0}
                        maxW={143}
                        maxH={49}
                        fs={14}
                        mr={10}
                        className={"app-save-btn normal-imp" + enableSavebtn()}
                        onClick={onSaveAddress}
                      >
                        Save Address
                      </Div>
                      <div className="address-save-separater" />
                      <div className="co-w-20per ml-2">
                        <TextField
                          label="Latitude"
                          className="co-location-row-one"
                          variant="outlined"
                          disabled={!longitude && !latitude && !lat && !long}
                          value={latitude}
                          onChange={(e) => setLatitude(e.target.value)}
                        />
                      </div>
                      <div className="co-w-20per ml-1">
                        <TextField
                          label="Longitude"
                          className="co-location-row-one"
                          disabled={!longitude && !latitude && !lat && !long}
                          variant="outlined"
                          value={longitude}
                          onChange={(e) => setLongitude(e.target.value)}
                        />
                      </div>
                    </Div>

                    <div className="flex ipca-m-t-30">
                      <img
                        alt=""
                        height={32}
                        src="/self-serve/service@3x.png"
                      />
                      <span className="ipca-reason-cancel">
                        Special Instructions
                      </span>
                      <span className="ipca-optional ipca-reason-cancel">
                        Optional
                      </span>
                    </div>
                    <div className="mt-2 ipca-infectious">
                      <TextField
                        id="outlined-multiline-static"
                        className="w-full ipca-textarea"
                        placeholder="e.g. My father was discharged from hospital one week ago and my brother will be around during the session."
                        multiline
                        rows={2}
                        value={instruction}
                        onChange={(e: any) => setinstruction(e.target.value)}
                        variant="outlined"
                      />
                    </div>
                  </div>
                </div>
                <div className="ipca-btn-right">
                  <button
                    onClick={() => checkTimeSlots()}
                    disabled={isTimeSlot ? false : true}
                    className={
                      isTimeSlot
                        ? " time-slot time-slot2 ipca-m-t-30"
                        : "time-slot ipca-m-t-30"
                    }
                  >
                    Next: Time Slot
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div
                  className="scheduled-ass flex mr-8 pointer ipca-sb"
                  onClick={() => setScheduled(false)}
                >
                  <div className="flex align-center ipca-h-85">
                    <span className="ipca-img-bottom-align ipca-h-85">
                      <img
                        src="/self-serve/assessment@3x.png"
                        alt=""
                        height={72}
                        width={82}
                      />
                    </span>
                    <div>
                      <div className="co-general-text ml-8">
                        Assessment Booking Info
                      </div>
                      <span className="for ml-8">
                        For: {firstName}, {age} years old
                      </span>
                    </div>
                  </div>
                  <div className="ipca-filled-img">
                    <img
                      alt=""
                      height={25}
                      src="/self-serve/filled-done@3x.png"
                    />
                  </div>
                </div>
                {booking && (
                  <>
                    <div
                      className="scheduled-ass flex mr-8 pointer ipca-sb"
                      onClick={() => setBooking(false)}
                    >
                      <div className="flex align-center ipca-h-85">
                        <span className="ipca-img-bottom-align ipca-h-85">
                          <img
                            src="/self-serve/slots@3x.png"
                            alt=""
                            height={63}
                            width={82}
                          />
                        </span>

                        <div>
                          <div className="co-general-text ml-8">
                            Assessment Slot
                          </div>
                          <span className="for ml-8">
                            {slotsBooked.length > 0 && (
                              <>
                                {new Date(slotsBooked[0].item).getDate()}{" "}
                                {
                                  getShortMonths()[
                                  new Date(slotsBooked[0].item).getMonth()
                                  ]
                                }{" "}
                                | {slotsBooked[0].slot}
                              </>
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="ipca-filled-img">
                        <img
                          alt=""
                          height={25}
                          src="/self-serve/filled-done@3x.png"
                        />
                      </div>
                    </div>
                    <Div
                      pl={22}
                      className={
                        collapse
                          ? "co-header-element flex justify-between bg-transparent mr-8 ipca-m-t-20"
                          : "co-header-element flex justify-between mr-8 ipca-m-t-20"
                      }
                    >
                      <div className="flex align-center">
                        <span className="ipca-img-bottom-align ippca-h-72">
                          <img
                            src="/self-serve/payment@3x.png"
                            alt=""
                            height={63}
                            width={82}
                          />
                        </span>

                        <div className="co-general-text ml-8">Payment Info</div>
                      </div>
                    </Div>
                    {cardInfo.number ? (
                      <div className="ipca-card-info-div">
                        <div className="ipca-save-card-img">
                          <img
                            src="/self-serve/saved-card_green@3x.png"
                            alt=""
                            height={32}
                          />
                          <span className="saved-card">Saved Card</span>
                        </div>
                        <div className="flex justify-between">
                          <div className="visa-div">
                            <div className="flex justify-between ipca-ending-with">
                              <div className="flex">
                                <img
                                  alt=""
                                  height={18}
                                  src={
                                    cardInfo.icon
                                      ? cardInfo.icon
                                      : "/self-serve/saved-card_green@3x.png"
                                  }
                                />

                                <span className="ending-with-4242">
                                  Ending with {cardInfo.number}
                                </span>
                              </div>
                              <div>
                                <img
                                  alt=""
                                  onClick={() =>
                                    setCardInfo({ number: "", icon: "" })
                                  }
                                  className="pointer"
                                  height={18}
                                  src="/self-serve/pencil-edit@3x.png"
                                />
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className="assessment-cost">
                              Assessment Cost
                            </div>
                            <div className="sgd-60-00">{ipca_pricing}</div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="ipca-card-info-div">
                        <div className="ipca-save-card-img">
                          <img
                            src="/self-serve/saved-card_green@3x.png"
                            alt=""
                            height={32}
                          />
                          <span className="saved-card">
                            Please setup the card
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <div className="flex">
                            <div className="ipca-sb-50">
                              <Elements stripe={stripePromise}>
                                <CheckoutForm
                                  onSubmit2={(res: any) => BookWithCard(res)}
                                />
                              </Elements>
                            </div>
                          </div>

                          <div>
                            <div className="assessment-cost">
                              Assessment Cost
                            </div>
                            <div className="sgd-60-00">{ipca_pricing}</div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="payment-right ipca-m-r-32">
                      <button
                        onClick={() => confirmingBooking()}
                        className="payment"
                      >
                        {bookingLoading && (
                          <ClipLoader
                            size={20}
                            color={"#fff"}
                            css="margin-right: 10px;
                                  position: relative;
                                  top: 5px;"
                            loading={bookingLoading}
                          />
                        )}
                        <span>Confirm Booking</span>
                      </button>
                    </div>
                  </>
                )}

                {slotTaken && (
                  <PortalDialog className="ha-dialog ha-dialog-appear ipca-slot-dial">
                    <div>
                      <img
                        alt=""
                        className="ipca-img-app-confirm"
                        height={146}
                        src="/self-serve/slot-taken-graphic@3x.png"
                      />
                      <span className="scheduling-your-appo ">Slot taken!</span>
                      <div className="we-have-informed-the">
                        This slot has been booked by other customers, please
                        select another slot.
                      </div>
                      <button
                        onClick={() => {
                          setBooking(false);
                          setSlotTaken(false);
                        }}
                        className="home ipca-new-slot"
                      >
                        <span className="ipca-f-18">Select a new slot</span>
                      </button>
                    </div>
                  </PortalDialog>
                )}
                {emailSuccess && (
                  <PortalDialog className="ha-dialog ha-dialog-appear ipca-email-dial">
                    <div className="vs-dialog-close-container ipca-float-r">
                      <div className="small-icon ipca-icon-container">
                        <IconButton
                          className="vs-dialog-close"
                          onClick={async () => {
                            await updateCRData();
                            refreshCareownerData();
                            setEmailSuccess(false);
                            setScheduled(false);
                            parentSetState((prevState: any) => ({
                              ...prevState,
                              scheduleIpca: false,
                            }));
                          }}
                          aria-label="close"
                        >
                          <Close />
                        </IconButton>
                      </div>
                    </div>
                    <div className="flex justify-between center ipca-h-100">
                      <img
                        alt=""
                        className="ipca-m-r-26"
                        height={54}
                        src="/self-serve/email-success@3x.png"
                      />
                      <div>
                        <span className="ipca-success">Success!</span>
                        <div className="ipca-success-email-text">
                          An email with the payment link has been sent to the
                          customer.
                        </div>
                      </div>
                    </div>
                  </PortalDialog>
                )}

                {appointmentConfirmed && (
                  <PortalDialog className="ha-dialog-appear ipca-app-dialog">
                    <div className="vs-dialog-close-container ipca-float-r">
                      <div className="small-icon ipca-icon-container">
                        <IconButton
                          className="vs-dialog-close"
                          onClick={async () => {
                            await updateCRData();
                            refreshCareownerData();
                            setScheduled(false);
                            setappointmentConfirmed(false);
                            parentSetState({
                              ...parentState,
                              scheduleIpca: false,
                            });
                          }}
                          aria-label="close"
                        >
                          <Close />
                        </IconButton>
                      </div>
                    </div>
                    <div>
                      <img
                        alt=""
                        className="ipca-img-app-confirm"
                        height={136}
                        src="/self-serve/appointment-confirm-grphic@3x.png"
                      />
                      <img
                        className="ipca-filled-confirmed"
                        src="/self-serve/filled-done@3x.png"
                        alt=""
                        height={34}
                      />
                      <span className="scheduling-your-appo ">
                        Appointment confirmed
                      </span>
                      <div className="we-have-informed-the">
                        We have informed the Care Specialist assigned and
                        blocked the date on their calendar. This will also
                        trigger an email and push notification to the customer.
                      </div>
                    </div>
                  </PortalDialog>
                )}
                {showPaymentMethods && (
                  <PortalDialog className="ha-dialog ha-dialog-appear ipca-payment-dial">
                    <div className="vs-dialog-close-container ipca-float-r">
                      <div className="small-icon ipca-icon-container">
                        <IconButton
                          className="vs-dialog-close"
                          onClick={() => setShowPaymentMethods(false)}
                          aria-label="close"
                        >
                          <Close />
                        </IconButton>
                      </div>
                    </div>
                    <div>
                      <div className="how-does-the-custome">
                        How does the customer prefers to pay?
                      </div>
                      <div className="the-customer-wants-t ">
                        The customer wants to:
                      </div>
                      <Div h w100>
                        <Div
                          className="ipca-border-btn"
                          h
                          hc
                          vc
                          onClick={() => getCardInfo("on call")}
                        >
                          <Img src="/self-serve/pay-oncall@3x.png" />
                          <span>Pay on Call</span>
                        </Div>

                        <Div
                          className={
                            "ipca-green-btn" +
                            (payThemselvesDisabled ? " disabled" : "")
                          }
                          h
                          hc
                          vc
                          onClick={
                            payThemselvesDisabled
                              ? UNDEF
                              : () => getCardInfo("in app")
                          }
                        >
                          <Img src="/self-serve/pay-web-white@3x.png" />
                          <Div v hc>
                            <span>Pay themselves</span>
                            <Txt l fs={14} mt={-5} textAlign="center">
                              (Share a link)
                            </Txt>
                          </Div>
                        </Div>
                      </Div>
                    </div>
                  </PortalDialog>
                )}

                {schedulingAppointment && (
                  <PortalDialog className="ha-dialog ha-dialog-appear ipca-schedule-dial">
                    <div className="vs-dialog-close-container ipca-float-r">
                      <div className="small-icon ipca-icon-container">
                        <IconButton
                          className="vs-dialog-close"
                          aria-label="close"
                        >
                          <Close />
                        </IconButton>
                      </div>
                    </div>
                    <div>
                      <img
                        alt=""
                        className="ipca-img-app-confirm"
                        height={146}
                        src="/self-serve/scheduling-graphic@3x.png"
                      />
                      <span className="scheduling-your-appo ">
                        {parentState.updateAppointment
                          ? "Updating "
                          : "Scheduling "}
                        your appointment…
                      </span>
                      <div className="progress-bar">
                        <div
                          style={{ width: progressWidth + "%" }}
                          className="progress-bar-filled"
                        ></div>
                      </div>
                    </div>
                  </PortalDialog>
                )}

                {!booking && (
                  <>
                    <Div
                      pl={24}
                      className={
                        collapse
                          ? "co-header-element flex justify-between bg-transparent mr-8 ipca-m-t-20"
                          : "co-header-element flex justify-between mr-8 ipca-m-t-20"
                      }
                    >
                      <div className="flex align-center">
                        <span className="ipca-img-bottom-align ipca-h-72">
                          <img
                            src="/self-serve/slots@3x.png"
                            alt=""
                            height={63}
                            width={82}
                          />
                        </span>

                        <div className="co-general-text ml-8">
                          Assessment Slot
                        </div>
                      </div>
                    </Div>
                    <div className="box mr-8">
                      <div className="inside-box">
                        <div className="flex justify-between ipca-border-bottom">
                          <div className="ipca no-border ipca-select-div">
                            <SimpleSelect
                              value={selectedMonth}
                              label=""
                              dropdownData={monthDropdown}
                              validate={validate}
                              onChange={(e: any) => updateMonth(e)}
                            />
                          </div>
                          <div className="flex center">
                            <img
                              alt=""
                              className="pointer"
                              onClick={() => removeIndexPair()}
                              height={32}
                              src="/self-serve/calendar-arrow@3x.png"
                            />
                            <img
                              alt=""
                              className="pointer ipca-m-cal"
                              onClick={() => addIndexPair()}
                              height={32}
                              src="/self-serve/calendar-arrow-next@3x.png"
                            />
                          </div>
                        </div>
                        {
                          <div className="flex ipca-border-bottom">
                            {pair.map((item: any, index) => {
                              return (
                                <div
                                  key={index}
                                  style={
                                    index === 3
                                      ? {
                                        flex: "0 25%",
                                        padding: "8px",
                                      }
                                      : {
                                        flex: "0 25%",
                                        borderRight: "1px solid lightgray",
                                        padding: "8px",
                                      }
                                  }
                                >
                                  <div
                                    style={
                                      new Date().toDateString() ===
                                        new Date(item.day).toDateString()
                                        ? { color: "#32BDC7" }
                                        : {}
                                    }
                                    className="sunday-div"
                                  >
                                    {getDayNames()[new Date(item.day).getDay()]}
                                  </div>
                                  <div
                                    style={
                                      new Date().toDateString() ===
                                        new Date(item.day).toDateString()
                                        ? { color: "#32BDC7" }
                                        : {}
                                    }
                                    className="d-20"
                                  >
                                    {new Date(item.day).getDate()}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        }
                        {
                          <div className="flex">
                            {pair.map((item2: any, index) => {
                              return (
                                <React.Fragment key={item2.day}>
                                  <div className="ipca-slot-div">
                                    {item2 &&
                                      item2.slots &&
                                      item2.slots.map((obj: any) => {
                                        return (
                                          <div
                                            key={obj.time + item2.day}
                                            onClick={() =>
                                              obj.available &&
                                              ToggleSlot(obj.time, item2)
                                            }
                                            className={
                                              obj.available
                                                ? checkBooked(obj.time, item2)
                                                  ? "ipca-slot ipca-slot-enabled"
                                                  : "ipca-slot"
                                                : "ipca-slot  ipca-slot-disabled"
                                            }
                                          >
                                            {obj.time}
                                          </div>
                                        );
                                      })}
                                  </div>
                                </React.Fragment>
                              );
                              // }
                            })}
                          </div>
                        }
                      </div>
                      <div className="payment-right">
                        <button
                          onClick={handleNextPayment}
                          disabled={slotsBooked.length > 0 ? false : true}
                          className={
                            slotsBooked.length === 1
                              ? "payment"
                              : "payment payment-disabled"
                          }
                        >
                          {parentState.updateAppointment
                            ? "Confirm Change Appointment"
                            : "Next: Payment"}
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </>
        )}
      </>
    );
  }
);
const mapStateToProps = ({ recipientStore: { states } }: any) => ({
  states,
});

export default connect(mapStateToProps, { getStates })(
  memo(withRouter(MedicalBackground))
);
